import Observable from 'observable_js';

export default class CookieManager extends Observable{
	constructor() {
		super();
	}

	trim(str) {
		return str.replace(/(^\s+|\s+$)/g, "");
	}
	// {name:String, value:String, days:Number}
	setCookie(obj) {

		var name = obj.name,
		value = encodeURI(obj.value),
		days = obj.days,
		date = new Date(),
		success = false;

		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

		try {
			document.cookie = name + "=" + value + "; expires=" + date.toGMTString() + "; path=/";
			success = true;
		} catch (e) {
			success = false;
		}
		return success;
	}

	getCookie(name) {
		var cookies = document.cookie.split(";"),
		cookie,
		i;

		for (i = 0; i < cookies.length; i += 1) {
			cookie = this.trim(cookies[i]) || "";

			if (cookie.indexOf(name) === 0) {
				return cookie.split("=")[1];
			}
		}

		return "";
	}

}



// WEBPACK FOOTER //
// ./src/js_global/objects/CookieManager.js